export const SET_SPRACHTEXTE = "setSprachTexte";
